module.exports = __webpack_public_path__ + "img/support_js_02@2x.17fd0e31.png";